module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-polo-uniforme-personalizado-768x591.6e8222f2.jpg";